<template>
  <pf-background-image :src="backgroundImage" />

  <pf-login-page :title="$t('Pagina non trovata')" :brand-img-src="LogoSVG">
    {{ $t('Torna alla') }}
    <router-link :to="{ name: 'dashboard' }">{{ $t('dashboard') }}</router-link>.
  </pf-login-page>
</template>

<script lang="ts" setup>
import LogoSVG from '@/assets/logo.svg';

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const backgroundImage = 'https://www.artera.net/wp-content/uploads/2018/05/main-photo.jpg';
</script>
